import React from 'react';
import feesImg from '../images/feesImg.jpeg';

function HowToPay() {
  const bannerStyle = {
    width: '100%',
    height: '500px',
    backgroundImage: `url(${feesImg})`,
    backgroundSize: '85%',
    backgroundPosition: '45% 67%',
    backgroundRepeat: 'no-repeat',
  };

  const contentStyle = {
    padding: '40px 20px',
    maxWidth: '900px',
    margin: '0 auto',
    textAlign: 'center',
  };

  const tableStyle = {
    width: '100%',
    marginTop: '30px',
    borderCollapse: 'collapse',
  };

  const thTdStyle = {
    border: '1px solid #ccc',
    padding: '12px',
    fontSize: '16px',
  };

  const headerStyle = {
    backgroundColor: '#f0f8ff',
    fontWeight: 'bold',
  };

  return (
    <div>
      <div style={bannerStyle}></div>

      <div style={contentStyle}>
        <h1>How to Pay</h1>
        <p>
          At Highlands College, we offer multiple easy ways to pay school fees.
          You can pay via bank transfer or in person at our office (CARD ONLY).
          Please follow the instructions provided in your welcome packet or contact the school office for help.
        </p>

        <h2>2026 Registration Fees</h2>
        <ul style={{ textAlign: 'left', margin: '20px auto', maxWidth: '600px' }}>
          <li><strong>New Registration:</strong> R1600.00</li>
          <li><strong>Re-Registration:</strong> R1000.00 <em>(from 22nd July – 31st October 2025)</em></li>
        </ul>

        <h2>2026 School Fees (Monthly)</h2>
        <p><em>Textbooks not included in the fees below.</em></p>

        <table style={tableStyle}>
          <thead>
            <tr style={headerStyle}>
              <th style={thTdStyle}>Grade</th>
              <th style={thTdStyle}>Monthly Fee (ZAR)</th>
              <th style={thTdStyle}>Annual Total (ZAR)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={thTdStyle}>Grade R</td>
              <td style={thTdStyle}>1,600</td>
              <td style={thTdStyle}>19,200</td>
            </tr>
            <tr>
              <td style={thTdStyle}>Grade 1</td>
              <td style={thTdStyle}>1,800</td>
              <td style={thTdStyle}>21,600</td>
            </tr>
            <tr>
              <td style={thTdStyle}>Grade 2</td>
              <td style={thTdStyle}>1,800</td>
              <td style={thTdStyle}>21,600</td>
            </tr>
            <tr>
              <td style={thTdStyle}>Grade 3</td>
              <td style={thTdStyle}>1,850</td>
              <td style={thTdStyle}>22,200</td>
            </tr>
            <tr>
              <td style={thTdStyle}>Grade 4</td>
              <td style={thTdStyle}>1,850</td>
              <td style={thTdStyle}>22,200</td>
            </tr>
            <tr>
              <td style={thTdStyle}>Grade 5</td>
              <td style={thTdStyle}>1,900</td>
              <td style={thTdStyle}>22,800</td>
            </tr>
            <tr>
              <td style={thTdStyle}>Grade 6</td>
              <td style={thTdStyle}>1,950</td>
              <td style={thTdStyle}>23,400</td>
            </tr>
            <tr>
              <td style={thTdStyle}>Grade 7</td>
              <td style={thTdStyle}>2,000</td>
              <td style={thTdStyle}>24,000</td>
            </tr>
          </tbody>
        </table>

        <h3 style={{ marginTop: '40px' }}>For Further Information</h3>
        <p>Contact Vonia: <strong>083 569 0146</strong></p>
      </div>
    </div>
  );
}

export default HowToPay;
